import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Modal,
	Form,
	Input,
	Row,
	Col,
	Select,
	InputNumber,
} from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
const { Title } = Typography;

const optionsTestingAge = [
	{ value: "Break @ 1 days A", label: "Break @ 1 days A" },
	{ value: "Break @ 1 days B", label: "Break @ 1 days B" },
	{ value: "Break @ 3 days A", label: "Break @ 3 days A" },
	{ value: "Break @ 3 days B", label: "Break @ 3 days B" },
	{ value: "Break @ 7 days A", label: "Break @ 7 days A" },
	{ value: "Break @ 7 days B", label: "Break @ 7 days B" },
	{ value: "Break @ 14 days A", label: "Break @ 14 days A" },
	{ value: "Break @ 14 days B", label: "Break @ 14 days B" },
	{ value: "Break @ 28 days A", label: "Break @ 28 days A" },
	{ value: "Break @ 28 days B", label: "Break @ 28 days B" },
	{ value: "Break @ 28 days C", label: "Break @ 28 days C" },
	{ value: "Break @ 56 days A", label: "Break @ 56 days A" },
	{ value: "Break @ 56 days B", label: "Break @ 56 days B" },
	{ value: "Break @ 56 days C", label: "Break @ 56 days C" },
	{ value: "Break @ 90 days A", label: "Break @ 90 days A" },
	{ value: "Break @ 90 days B", label: "Break @ 90 days B" },
	{ value: "Break @ 90 days C", label: "Break @ 90 days C" },
];

const QAQCBreakDayModal = ({
	modalOpenBreakDay,
	setModalOpenBreakDay,
	selectedLoad,
	setSelectedLoad,
	setRefresh,
}) => {
	const [loading, setLoading] = useState(true);
	const [loadingForm, setLoadingForm] = useState(false);
	const [form] = Form.useForm();
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		if (selectedLoad) getLoadData();
	}, [selectedLoad]);

	const getLoadData = async () => {
		try {
			setLoading(true);
			const url = api + `/job/get/qc/load/${selectedLoad.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let breakDayAge = [];

				if (data.payload.qcData.breakDayAge.length !== 0) {
					form.setFieldsValue({ breakDayAge: data.payload.qcData.breakDayAge });
				} else {
					data.payload.qcData.specimensIDS.map((id) => {
						breakDayAge.push({
							specimenId: id,
							testingAge: undefined,
							age: undefined,
						});
					});
					form.setFieldsValue({ breakDayAge });
				}
				setLoading(false);
			} else {
				setLoading(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const onFinish = async () => {
		const values = form.getFieldsValue(true);

		try {
			setLoadingForm(true);
			const url = api + `/job/update/qc/load/testingage/${selectedLoad.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, values);
			if (data.success) {
				openNotification("success", "Updated", data.message);
				setTimeout(() => {
					form.resetFields();
					setLoadingForm(false);
					setSelectedLoad(undefined);
					setModalOpenBreakDay(false);
					setRefresh((prev) => !prev);
				}, 2000);
			} else {
				setLoadingForm(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const onTestingAgeChange = (value, name) => {
		const match = value.match(/\d+/);
		const age = match ? parseInt(match[0]) : undefined;

		const breakDayAge = form.getFieldValue("breakDayAge");
		breakDayAge[name].age = age;
		form.setFieldsValue({ breakDayAge });
	};

	const RenderForm = () => {
		return (
			<Form form={form} onFinish={onFinish} layout="vertical">
				<Form.List name="breakDayAge">
					{(fields) => (
						<>
							{fields.map(({ key, name, ...restField }) => (
								<Row gutter={16}>
									<Col span={12}>
										<Form.Item
											{...restField}
											label="Specimen ID"
											name={[name, "specimenId"]}
											rules={[
												{ required: true, message: "Missing Specimen ID" },
											]}
										>
											<Input size="large" disabled />
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item
											{...restField}
											label="Testing Age"
											name={[name, "testingAge"]}
											rules={[
												{ required: true, message: "Missing Testing Age" },
											]}
										>
											<Select
												size="large"
												options={optionsTestingAge}
												onChange={(value) => onTestingAgeChange(value, name)}
											/>
										</Form.Item>
									</Col>
									<Form.Item
										{...restField}
										hidden
										name={[name, "age"]}
										rules={[{ required: true, message: "Missing age" }]}
									>
										<InputNumber size="large" />
									</Form.Item>
								</Row>
							))}
						</>
					)}
				</Form.List>
				<Form.Item>
					<Button
						type="primary"
						size="large"
						htmlType="submit"
						loading={loadingForm}
					>
						Submit
					</Button>
				</Form.Item>
			</Form>
		);
	};

	return (
		<Modal
			title={`Load ID: ${selectedLoad?.deliveryTicket}`}
			open={modalOpenBreakDay}
			onCancel={() => {
				form.resetFields();
				setSelectedLoad(undefined);
				setModalOpenBreakDay(false);
			}}
			footer={null}
			width={800}
			centered
		>
			<Flex vertical gap={16}>
				<Title level={4}>Add Testing Age</Title>
				{loading ? <CustomSpinner /> : <RenderForm />}
			</Flex>
			{contextHolder}
		</Modal>
	);
};

export default QAQCBreakDayModal;
